<template>
	<div class="box" v-if="popState" @click="popClose">
		<div class="popBox" @click.stop="1">
			<div class="title">{{title}}</div>
			<div class="inputBox" style="margin-bottom: 10px;">
				<div class="inputTxt">{{this.$t('yhm')}}:</div>
				<input type="text" class="inputContent" v-model="nameVal" :placeholder="namePlaceholder"/>
			</div>
			<div class="inputBox">
				<div class="inputTxt">{{this.$t('mm')}}:</div>
				<input type="password" class="inputContent" v-model="passwordVal" :placeholder="paswodPlaceholder"/>
			</div>
			<div class="btn" @click="popConfirm">{{btnTxt}}</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			title:{
				type:String,
				default:'人员删除'
			},
			btnTxt:{
				type:String,
				default:'确认'
			},
			popState:{
				type:Boolean,
				default:false
			},
			namePlaceholder:{
				type:String,
				default:'请输入用户名'
			},
			paswodPlaceholder:{
				type:String,
				default:'请输入密码'
			}
		},
		data(){
			return {
				nameVal:'',
				passwordVal:''
			}
		},
		methods:{
			popConfirm(){
				this.$emit('popConfirm',[this.nameVal,this.passwordVal])
			},
			popClose(){
				this.$emit('popClose')
			},
			
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.6);
		position: fixed;
		top: 0;
	}
	.popBox{
		background-color: #fff;
		width: 80%;
		margin: auto;
		margin-top: 225px;
		border-radius: 10px;
		padding: 20px 0;
	}
	.title{
		font-size: 20px;
		display: flex;
		justify-content: center;
		margin-bottom: 20px;
	}
	.inputBox{
		display: flex;
		padding-right: 20px;
	}
	.inputTxt{
		flex: 3;
	}
	.inputContent{
		width: 150px;
	}
	.btn{
		width: 75px;
		height: 40px;
		background-color: #1ABC9C;
		color: #fff;
		line-height: 40px;
		text-align: center;
		border-radius: 10px;
		margin: 0 auto;
		margin-top: 20px;
	}
</style>
